import { defineStore } from 'pinia';
import { type SuiSelectListItemsAndGroupsValueType } from '@developers/scoro-ui';
import {
	type Trigger,
	TriggerFilterDataLogicalOperator,
	type TriggersActionsModifyQuery,
} from '@/generated/graphql';
import { ModifyTabs } from './constants';
import { type ValueOf } from '@/types';

export type TriggersActionsStoreType = {
	actions: TriggersActionsModifyQuery['Trigger']['actions'];
	activities: TriggersActionsModifyQuery['Trigger']['activities'];
	bookmark?: TriggersActionsModifyQuery['Trigger']['bookmark'];
	filters: TriggersActionsModifyQuery['Trigger']['filterData']['filters'];
	filtersActivities: TriggersActionsModifyQuery['Trigger']['filterData']['activities'];
	filtersActivityDoers: SuiSelectListItemsAndGroupsValueType;
	id: Trigger['id'];
	module: TriggersActionsModifyQuery['Trigger']['module'] | undefined;
	customModule?: TriggersActionsModifyQuery['Trigger']['customModule'];
	name: TriggersActionsModifyQuery['Trigger']['name'];
	status?: TriggersActionsModifyQuery['Trigger']['status'];
	user?: TriggersActionsModifyQuery['Trigger']['user'];
	modifyFormTab: ValueOf<typeof ModifyTabs>;
	isTemplate: boolean;
	isSystemNotification: boolean | undefined;
	isSaveEnabled: boolean;
	hasErrorsInConditions: boolean;
	hasErrorsInActivities: boolean;
};

export const useTriggersActionsStore = defineStore('triggersActions', {
	state: (): TriggersActionsStoreType => {
		return {
			id: '',
			name: '',
			status: undefined,
			module: undefined,
			customModule: undefined,
			actions: [],
			activities: [],
			bookmark: undefined,
			isTemplate: false,
			isSystemNotification: false,
			filters: {
				blocks: [],
				logicalOperator: TriggerFilterDataLogicalOperator.Or,
			},
			filtersActivities: {
				blocks: [],
				logicalOperator: TriggerFilterDataLogicalOperator.Or,
			},
			filtersActivityDoers: {
				groupIds: [],
				itemIds: [],
			},
			user: undefined,
			isSaveEnabled: false,
			modifyFormTab: ModifyTabs.Trigger,
			hasErrorsInConditions: false,
			hasErrorsInActivities: false,
		};
	},
});
